/**
 * SystemHealthPage - Overall system health monitoring
 *
 * Surfaces the SystemHealthDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides real-time visibility into system health, resource utilization, and alerts.
 *
 * Route: /admin/system-health
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconHeartRateMonitor } from '@tabler/icons-react';

import { SystemHealthDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function SystemHealthPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="green">
            <IconHeartRateMonitor size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>System Health</Title>
            <Text size="sm" c="dimmed">
              Real-time system health, resource utilization, and service status
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <SystemHealthDashboard />
    </Container>
  );
}

export default SystemHealthPage;
